import React from 'react';
export function Footer() {
  return <footer className="bg-black py-8 px-3" data-id="element-74">
      <div className="max-w-4xl mx-auto text-center space-y-3" data-id="element-75">
        <p className="font-display text-lg text-accent font-semibold" data-id="element-76">
          SALUD EN TU PLATO™
        </p>
        <p className="text-xs text-white/30" data-id="element-77">
          © Sistema Clínico Pro Elite™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}